/**
 * --------------------------------------------------------------------------
 * Mixin created to generate background-color and color contrasting with
 * background-color to be used in avatar
 * --------------------------------------------------------------------------
 */
export default {
    data() {
        return {
            backgroundColors: [
                '#F44336',
                '#FF4081',
                '#9C27B0',
                '#673AB7',
                '#3F51B5',
                '#2196F3',
                '#03A9F4',
                '#00BCD4',
                '#009688',
                '#4CAF50',
                '#8BC34A',
                '#CDDC39',
                '#FFC107',
                '#FF9800',
                '#FF5722',
                '#795548',
                '#9E9E9E',
                '#607D8B',
            ],
        }
    },
    methods: {
        /**
         * @param {int} seed any value
         * @returns {string} valid hex color
         */
        randomBackgroundColor(seed = 1) {
            const randomColor = ((Math.random() * 0xffffff) << 0)
                .toString(16)
                .padStart(6, '0')

            let hexColor = '#' + randomColor

            if (!this.isValidHexColor(hexColor)) {
                const randomIndex = seed % this.backgroundColors.length
                hexColor = this.backgroundColors[randomIndex]
            }
            return hexColor
        },
        /**
         * @param {string} hex Hexadecimal color
         * @returns {string} Hexadecimal color
         *
         * @description Returns a lighter or darker color based on the color passed by the parameter
         */
        lightenDarkenColor(hex) {
            const isLighten = this.lightness(hex) > 160
            return isLighten ? '#000000' : '#ffffff'
        },
        /**
         * @param {string} hex Hexadecimal color
         * @returns {float}
         *
         * @description The function returns a float that ranges from 0 to 255.
         * The closer to zero, the color passed is dark and the closer to 255 is lighter
         */
        lightness(hex) {
            let r, g, b, isLongHex
            hex = hex.replace('#', '')
            isLongHex = hex.length == 6

            r = isLongHex
                ? parseInt(hex.substr(0, 2), 16)
                : parseInt(hex.substr(0, 1), 16) * 17
            g = isLongHex
                ? parseInt(hex.substr(2, 2), 16)
                : parseInt(hex.substr(1, 1), 16) * 17
            b = isLongHex
                ? parseInt(hex.substr(4, 2), 16)
                : parseInt(hex.substr(2, 1), 16) * 17

            return (r * 299 + g * 587 + b * 114) / 1000
        },
        isValidHexColor(hexColor) {
            return /^#[0-9A-F]{6}$/i.test(hexColor)
        },
    },
}
